import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import "../assets/style/support-article.css";
import { faPaypal } from "@fortawesome/free-brands-svg-icons";

const Support = () => (
	<section id="support-article">
		<h1>Support Us</h1>
		<p>Porn has destroyed many people of our generation, and have ruined the lives of many teenagers across the world. That's what nofapguidance is about, helping people in need. Therefore, any support is appreciated.</p>
		<h2>How can I help?</h2>
		<p>You can help by donating any amount of money through our PayPal.Me link. Every penny goes into creating more content to help more people.</p>
		<section className="warning">
			<h2><FontAwesomeIcon icon={faExclamationTriangle} /></h2>
			<div>
				<p>This is NOT a subscription to any of our plans. You can donate any amount you please to simply support us in our journey. If you'd like to subscribe to one our plans instead, please fill out <Link to="/new-request">this form</Link>.</p>
			</div>
		</section>
		<section className="info">
			<h2><FontAwesomeIcon icon={faPaypal} /></h2>
			<div>
				<p>All our transactions go through PayPal, and we have no exposure to any personal information in the process.</p>
			</div>
		</section>
		{ /* eslint-disable-next-line */ }
		<table border="0" cellpadding="10" cellspacing="0" align="center"><tr><td align="center"></td></tr><tr><td align="center"><a href="https://www.paypal.com/webapps/mpp/paypal-popup" title="How PayPal Works" onclick="javascript:window.open('https://www.paypal.com/webapps/mpp/paypal-popup','WIPaypal','toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=1060, height=700'); return false;"><img src="https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/logo-center/9_bdg_secured_by_pp_2line.png" border="0" alt="Secured by PayPal" /></a></td></tr></table>
		<a href="https://www.paypal.com/paypalme/bilalyounis" className="link">Support Us <FontAwesomeIcon icon={faPaypal} /></a>
	</section>
);

const SupportUsPage = () => (
	<>
		<Navbar />
		<Support />	
		<Footer />	
	</>
);

export default SupportUsPage;